import axios from "axios";

/**
 * Upload one or more files and return the first file URL.
 * @param {File[]} files
 * @param {(bool)=>void} setUploading optional
 * @param {(number)=>void} onProgress optional [0..100]
 * @returns {Promise<string|null>} mediaUrl
 */
export const uploadMedia = async (files, setUploading, onProgress) => {
  setUploading?.(true);
  try {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));

    const { data } = await axios.post(
      "https://evala-server-6356f19fc5a0.herokuapp.com/api/deck/upload",
      fd,
      {
        onUploadProgress: (evt) => {
          if (!evt.total) return;
          const pct = Math.round((evt.loaded * 100) / evt.total);
          onProgress?.(pct);
        },
      }
    );
    return data?.data?.[0]?.imgurl || null;
  } catch (err) {
    throw new Error("Failed to upload media: " + (err.response?.data?.message || err.message));
  } finally {
    setUploading?.(false);
  }
};
